export default {
  init() {
   jQuery(function () {
    // this is fix for the broken layout on back to blog
    let $grid = jQuery('#lightgallery');
    let $boxes = jQuery('.gallery-item');
    var $container = jQuery('#lightgallery');


    $boxes.fadeIn();
    $grid.isotope({
      itemSelector: '.gallery-item',
      //percentPosition: true,
      masonry: {
        columnWidth: '.gallery-item',
        gutter: '.gutter-sizer2',
      },
    });

    jQuery('#filters a').click(function () {
      var selector = jQuery(this).attr('data-filter');
      jQuery('.slick-carousel-cat-list a').removeClass('selected');
      jQuery(this).addClass('selected');
        
      $container.isotope({
        filter: selector,
      });
      return false;
    });
   
    // layout Isotope after each image loads
    $grid.imagesLoaded().progress(function () {
      $container.isotope('layout');
    });
  });
 
  /* $(document).ready(function() {
    let $grid = $('#isotope-list');
    $grid.lightGallery({
      'disableScrolling': true,
    }); 
  }); */
  jQuery(document).ready(function() {
    let $grid = jQuery('#lightgallery');
    $grid.lightGallery({
      selector: '.gallery-item',
      download: false,
      // eslint-disable-next-line no-undef
      // plugins: [lgVideo],
      videojs: true,

    });

    // eslint-disable-next-line no-undef
    lightGallery(document.getElementById('lightgallery'), {
videojs: true,
}); 


  });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



//////////////////
// WEBPACK FOOTER
// ./scripts/routes/home.js
// module id = 18
// module chunks = 0